/**
 * Impressum gemäß § 5 DDG (Digitale-Dienste-Gesetz) und § 18 MStV.
 * Inhalte aus dem Konzern-Impressum der NOVATUS Energie GmbH übernommen.
 */
import LegalLayout from "../components/LegalLayout";

const ImpressumPage = () => (
  <LegalLayout
    title="Impressum"
    subtitle="Angaben gemäß § 5 DDG / § 18 MStV"
    data-testid="impressum-page"
  >
    <section>
      <h2 data-testid="impressum-section-anbieter">Anbieter / Verantwortlich</h2>
      <p>
        <strong>NOVATUS Energie GmbH</strong>
        <br />
        Maximiliankorso 60
        <br />
        13465 Berlin
        <br />
        Deutschland
      </p>
    </section>

    <section>
      <h2>Vertreten durch</h2>
      <p>
        <strong>Geschäftsführer:</strong> Dipl.-Verw. Wiss. Christof Schirm
      </p>
    </section>

    <section>
      <h2>Kontakt</h2>
      <p>
        <strong>Telefon:</strong>{" "}
        <a href="tel:+493039820570" data-testid="impressum-tel">
          +49 (0)30 398205700
        </a>
        <br />
        <strong>E-Mail:</strong>{" "}
        <a href="mailto:info@novatus-se.com" data-testid="impressum-email">
          info@novatus-se.com
        </a>
      </p>
    </section>

    <section>
      <h2>Registereintrag</h2>
      <p>
        <strong>Registergericht:</strong> Amtsgericht Charlottenburg
        <br />
        <strong>Registernummer:</strong> HRB 222 580
      </p>
    </section>

    <section>
      <h2>Umsatzsteuer-ID</h2>
      <p>
        <strong>USt-IdNr.:</strong> DE 296 655 515
        <br />
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz
      </p>
    </section>

    <section>
      <h2>Inhaltlich verantwortlich nach § 18 Abs. 2 MStV</h2>
      <p>
        Christof Schirm
        <br />
        Maximiliankorso 60, 13465 Berlin
      </p>
    </section>

    <section>
      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noreferrer"
          data-testid="impressum-odr"
        >
          https://ec.europa.eu/consumers/odr
        </a>
        . Unsere E-Mail-Adresse findest du oben im Impressum.
      </p>
    </section>

    <section>
      <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </section>

    <section>
      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach
        den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
        jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
        oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
        allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
        ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
        entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>
    </section>

    <section>
      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
        Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
        Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
        erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
        konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
        Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
    </section>

    <section>
      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
        deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
        Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
        privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht
        vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
        Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </p>
    </section>

    <p className="text-xs text-novatus-text-3 mt-8">Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}</p>
  </LegalLayout>
);

export default ImpressumPage;
